(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-products-block"] && !Shopify.designMode) return;
  try {
    
  /* Add custom scripts here if needed */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-block"] && !Shopify.designMode) return;
  try {
    
  /* Add custom scripts here if needed */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-image-with-block-meta-ii"] && !Shopify.designMode) return;
  try {
    
  /* Add custom scripts here if needed */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-image-with-block-meta-iii"] && !Shopify.designMode) return;
  try {
    
  /* Add custom scripts here if needed */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-image-with-block-meta"] && !Shopify.designMode) return;
  try {
    
  /* Add custom scripts here if needed */

  } catch(e) { console.error(e); }
})();
})();
